const actionPrefix = (actionType) => `EditAppointment/${actionType}`;

export const SET_EDIT_MODE = actionPrefix`SET_EDIT_MODE`;
export const setEditMode = (mode) => ({
  type: SET_EDIT_MODE,
  payload: mode,
});

export const SAVE_TEMPORARY_APPOINTMENT = actionPrefix`SAVE_TEMPORARY_APPOINTMENT`;
export const saveTemporaryAppointment = (appointment) => ({
  type: SAVE_TEMPORARY_APPOINTMENT,
  payload: appointment,
});

export const REPLACE_TIME_FILTERS = actionPrefix`REPLACE_TIME_FILTERS`;
export const replaceTimeFilters = (filter) => ({
  type: REPLACE_TIME_FILTERS,
  payload: filter,
});

export const SAVE_TEMPORARY_JOURNEY_STATE = actionPrefix`SAVE_TEMPORARY_JOURNEY_STATE`;
export const saveTemporaryJourneyState = (journeyState) => ({
  type: SAVE_TEMPORARY_JOURNEY_STATE,
  payload: journeyState,
});
